<template>
  <div class="surface-design-print">
    <TopPanel
      @search="surfaceDesignPrintsStore.searchByItems"
      @sort-order="surfaceDesignPrintsStore.setSortOrderItems"
      @sort-option="surfaceDesignPrintsStore.sortItems"
      :sort-options="sortOptions"
      :title="surfaceDesignPrintsStore.selectedCollectionName"
      backLink="/user/surface-design-prints"
      backText="Back to all prints"
      :needExtra="false"
      :create="false"
      @rename="editModal"
      @del="delModal"
      @edit="$router.push('/user/surface-design-prints-edit')"
    >
    </TopPanel>
    <EmptyGrid
      v-if="surfaceDesignPrintsStore.itemsCount === 0"
      @create-new="$router.push('/user/surface-design-prints-edit')"
      :buttonPlusIcon="false"
      :buttonEditIcon="true"
    >
      <template v-slot:icon>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 22">
          <path d="M5.5 3.834a.75.75 0 0 0-.75.75v.395h-.395a.75.75 0 0 0-.75.75.75.75 0 0 0 .75.75h.395v4h-.395a.75.75 0 0 0-.75.75.75.75 0 0 0 .75.75h.395v4h-.395a.75.75 0 0 0-.75.75.75.75 0 0 0 .75.75h.395v.396a.75.75 0 0 0 .75.75.75.75 0 0 0 .75-.75v-.396h4v.396a.75.75 0 0 0 .75.75.75.75 0 0 0 .75-.75v-.396h4v.396a.75.75 0 0 0 .75.75.75.75 0 0 0 .75-.75v-.396h.396a.75.75 0 0 0 .75-.75.75.75 0 0 0-.75-.75h-.396v-4h.396a.75.75 0 0 0 .75-.75.75.75 0 0 0-.75-.75h-.396v-4h.396a.75.75 0 0 0 .75-.75.75.75 0 0 0-.75-.75h-.396v-.395a.75.75 0 0 0-.75-.75.75.75 0 0 0-.75.75v.395h-4v-.395a.75.75 0 0 0-.75-.75.75.75 0 0 0-.75.75v.395h-4v-.395a.75.75 0 0 0-.75-.75zm.75 2.645h4v4h-4v-4zm5.5 0h4v4h-4v-4zm-5.5 5.5h4v4h-4v-4zm5.5 0h4v4h-4v-4z" />
        </svg>
      </template>
      <template v-slot:title>This collection is empty</template>
      <template v-slot:text>Click “Edit” button to add prints</template>
      <template v-slot:button-text>Edit collection</template>
    </EmptyGrid>
    <div v-else class="items">
      <div  class="item" v-for="item in surfaceDesignPrintsStore.items" :key="item.id">
        <div class="img-container"><img :src="`https://cdn.patternfast.com${item.url}`"/></div>
        <p v-if="item.name">{{item.name}}</p>
      </div>
    </div>
    <PaginationComponent
      :limit="surfaceDesignPrintsStore.itemsParams.limit"
      :offset="surfaceDesignPrintsStore.itemsParams.offset"
      :total="surfaceDesignPrintsStore.itemsCount"
      @setOffset="setOffset"
    />
    <ModalComponent @close="surfaceDesignPrintsStore.renameModalToggle()" :show="surfaceDesignPrintsStore.renameModal" >
      <template v-slot:icon>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 22">
          <path d="M5.5 3.834a.75.75 0 0 0-.75.75v.395h-.395a.75.75 0 0 0-.75.75.75.75 0 0 0 .75.75h.395v4h-.395a.75.75 0 0 0-.75.75.75.75 0 0 0 .75.75h.395v4h-.395a.75.75 0 0 0-.75.75.75.75 0 0 0 .75.75h.395v.396a.75.75 0 0 0 .75.75.75.75 0 0 0 .75-.75v-.396h4v.396a.75.75 0 0 0 .75.75.75.75 0 0 0 .75-.75v-.396h4v.396a.75.75 0 0 0 .75.75.75.75 0 0 0 .75-.75v-.396h.396a.75.75 0 0 0 .75-.75.75.75 0 0 0-.75-.75h-.396v-4h.396a.75.75 0 0 0 .75-.75.75.75 0 0 0-.75-.75h-.396v-4h.396a.75.75 0 0 0 .75-.75.75.75 0 0 0-.75-.75h-.396v-.395a.75.75 0 0 0-.75-.75.75.75 0 0 0-.75.75v.395h-4v-.395a.75.75 0 0 0-.75-.75.75.75 0 0 0-.75.75v.395h-4v-.395a.75.75 0 0 0-.75-.75zm.75 2.645h4v4h-4v-4zm5.5 0h4v4h-4v-4zm-5.5 5.5h4v4h-4v-4zm5.5 0h4v4h-4v-4z" />
        </svg>
      </template>
      <template v-slot:title>Rename collection</template>
      <template v-slot:extra>
        <label class="edit-collection-field">
          <span>Collection Name</span>
          <input type="text" placeholder="" v-model="surfaceDesignPrintsStore.collectionName">
        </label>
      </template>
      <template v-slot:buttons>
        <ButtonSecondary class="small" @click.native="surfaceDesignPrintsStore.renameModalToggle()">
          Cancel
        </ButtonSecondary>
        <ButtonPrimary class="small" :disabled="surfaceDesignPrintsStore.collectionName?.length === 0"
          @click.native="updateCollection">
          Rename
        </ButtonPrimary>
      </template>
    </ModalComponent>
    <ModalComponent @close="surfaceDesignPrintsStore.delCollectionModalToggle()" type="error"
      :show="surfaceDesignPrintsStore.delCollectionModal">
      <template v-slot:title>Delete collection</template>
      <template v-slot:description>Are you sure? You will lose the prints that are in it</template>
      <template v-slot:buttons>
        <ButtonSecondary class="small" @click.native="surfaceDesignPrintsStore.delCollectionModalToggle()">
          Cancel
        </ButtonSecondary>
        <ButtonPrimary class="small" @click.native="deleteCollection">
          <template v-slot:icon>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="none" viewBox="0 0 21 20">
              <path d="M8 1.75c-.866 0-1.584.718-1.584 1.584v.916H3.834a.75.75 0 0 0-.75.75.75.75 0 0 0 .75.75h.916v10.916c0 .866.718 1.584 1.584 1.584h8.332c.866 0 1.584-.718 1.584-1.584V5.75h.916a.75.75 0 0 0 .75-.75.75.75 0 0 0-.75-.75h-2.582v-.916c0-.866-.718-1.584-1.584-1.584H8zm0 1.5h5c.055 0 .084.03.084.084v.916H7.916v-.916c0-.055.03-.084.084-.084zm-1.75 2.5h8.5v10.916c0 .055-.03.084-.084.084H6.334c-.055 0-.084-.03-.084-.084V5.75z" color="#000" style="-inkscape-stroke:none"/>
            </svg>
          </template>
          Delete
        </ButtonPrimary>
      </template>
    </ModalComponent>
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import { useSurfaceDesignPrintsStore } from '@/store/pinia/surfaceDesignPrints'
import TopPanel from '@/components/SurfaceDesign/TopPanel.vue'
import EmptyGrid from '@/components/Atoms/EmptyGrid.vue'
import ModalComponent from '@/components/Atoms/ModalComponent.vue'
import ButtonPrimary from '@/components/Atoms/ButtonPrimary.vue'
import ButtonSecondary from '@/components/Atoms/ButtonSecondary.vue'
import PaginationComponent from '@/components/Atoms/PaginationComponentLimit.vue'
export default {
  name: 'surfaceDesignPrint',
  data: () => ({
    sortOptions: [
      { name: 'Sort by', value: '' },
      { name: 'Name', value: 'name' },
      { name: 'Last edited', value: 'updatedAt' },
    ],
  }),
  components: {
    TopPanel,
    EmptyGrid,
    ModalComponent,
    ButtonPrimary,
    ButtonSecondary,
    PaginationComponent,
  },
  computed: {
    ...mapStores(useSurfaceDesignPrintsStore),
  },
  methods: {
    async setOffset (offset) {
      this.surfaceDesignPrintsStore.itemsParams.offset = offset
      const id = this.$route.params.id || this.surfaceDesignPrintsStore.selectedCollectionId
      await this.surfaceDesignPrintsStore.getItems(id)
    },
    deleteCollection () {
      this.surfaceDesignPrintsStore.deleteCollection()
      this.$router.push('/user/surface-design-prints/')
    },
    delModal () {
      this.surfaceDesignPrintsStore.delCollectionModalToggle()
      this.surfaceDesignPrintsStore.collectionId = this.surfaceDesignPrintsStore.selectedCollectionId
    },
    editModal () {
      this.surfaceDesignPrintsStore.renameModalToggle()
      this.surfaceDesignPrintsStore.collectionId = this.surfaceDesignPrintsStore.selectedCollectionId
      this.surfaceDesignPrintsStore.collectionName = this.surfaceDesignPrintsStore.selectedCollectionName
    },
    updateCollection () {
      this.surfaceDesignPrintsStore.selectedCollectionName = this.surfaceDesignPrintsStore.collectionName
      this.surfaceDesignPrintsStore.updateCollection()
    },
  },
  async beforeMount () {
    const id = this.$route.params.id || this.surfaceDesignPrintsStore.selectedCollectionId
    await this.surfaceDesignPrintsStore.getItems(id)
  },
}
</script>

<style lang="scss">
.surface-design-print {
  padding: 0 16px 40px 40px;
  .items {
    display: flex;
    gap: 40px;
    margin-top: 42px;
    text-align: center;
    flex-wrap: wrap;
    p {
      margin: 8px 0 0;
      font-size: 14px;
      color: var(--Text-Text_Primary);
    }
    .img-container {
      width: 95px;
      height: 95px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 8px;
      }
    }
  }
}
@media (max-width: 480px) {
  .surface-design-print {
    padding: 0;
    .buttons-group {
      max-width: 100%;
    }
  }
}
</style>
